import { Splide, SplideSlide } from "@splidejs/react-splide";
import '@splidejs/splide/css';
import Styles from "./styles.module.css";
import React, { useEffect, useRef, useState } from "react";
import { IoImageOutline } from "react-icons/io5";

type SpliderProps = {
  number: number;
  imageName: string[];
  // 求人編集のプレビュー時のみ true。画像未登録のときに NO IMAGE 枠を出す。
  preview?: boolean;
};

const RecruitSplider: React.FC<SpliderProps> = ({ number, imageName, preview }) => {

  const [ time, setTime ] = useState<number>(0);

  useEffect(() => {
    var timeInit = new Date().getTime();
    setTime(timeInit);
  }, []);

  const carouselRef = useRef<any>(null);
  const [ currentIndex, setCurrentIndex ] = useState(0);

  return (
    <>
      {/* 写真の右上に「1 / 5」、下にピンクの点(学生アプリの「写真で見る」と同じ) */}
      <div className={Styles.gallery}>
  <Splide
          ref={carouselRef}
          aria-label="私のお気に入りの画像集"
          options={{
            perPage: 1,
            arrows: false,
            pagination: false,
            // interval: 3000,
          }}
          onMove={(splide, newIndex) => {
            setCurrentIndex(newIndex);
          }}
        >
          {preview && imageName.length === 0 ?
            <SplideSlide>
              <div className={Styles.noImage}>
                <IoImageOutline className={Styles.noImageIcon} />
                <span>写真を追加するとここに表示されます</span>
              </div>
            </SplideSlide>
          : <></> }
          {1 <= imageName.length ?
            <SplideSlide>
              <img className={Styles.slideImg} src={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/recruitImage${number}%2Fresize_images%2F${imageName[0]}_1080x1080?alt=media&token=${time}`}
                alt="美容室 求人 memorii works" />
            </SplideSlide>
          : <></> }
          {2 <= imageName.length ?
            <SplideSlide>
              <img className={Styles.slideImg} src={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/recruitImage${number}%2Fresize_images%2F${imageName[1]}_1080x1080?alt=media&token=${time}`}
                alt="美容室 求人 memorii works" />
            </SplideSlide>
          : <></> }
          {3 <= imageName.length ?
            <SplideSlide>
              <img className={Styles.slideImg} src={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/recruitImage${number}%2Fresize_images%2F${imageName[2]}_1080x1080?alt=media&token=${time}`}
                alt="美容室 求人 memorii works" />
            </SplideSlide>
          : <></> }
        </Splide>
        {imageName.length > 1 && (
          <span className={Styles.badge}>{currentIndex + 1} / {imageName.length}</span>
        )}
      </div>
      {imageName.length > 1 && (
        <div className={Styles.dots}>
          {imageName.map((_, i) => (
            <span key={i} className={i === currentIndex ? `${Styles.dot} ${Styles.dot_active}` : Styles.dot} />
          ))}
        </div>
      )}
    </>
  );
}

export default RecruitSplider;
